import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { AppointmentCard } from '../components/appointments/AppointmentCard';
import { apptT } from '../components/appointments/apptI18n';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AppointmentResponsePage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [appt, setAppt] = useState(null);
  const [lang, setLang] = useState(['it', 'en', 'de', 'fr'].includes(params.get('lang')) ? params.get('lang') : 'it');
  const [error, setError] = useState('');
  const [failed, setFailed] = useState(false);
  const t = apptT[lang];

  useEffect(() => {
    axios.get(`${API}/appointments/${id}`, { params: { token } })
      .then((r) => { setAppt(r.data); if (!params.get('lang')) setLang(r.data.language); })
      .catch(() => setFailed(true));
  }, [id, token]); // eslint-disable-line react-hooks/exhaustive-deps

  const respond = async (action, note) => {
    setError('');
    try {
      const r = await axios.post(`${API}/appointments/${id}/respond`, { token, action, note });
      setAppt({ ...appt, ...r.data });
    } catch (e) {
      setError(e.response?.data?.detail === 'past' ? t.past : t.error);
      throw e;
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] pt-32 pb-16 px-4">
      <div className="max-w-lg mx-auto bg-white rounded-2xl shadow-sm p-6 md:p-8 border-t-4 border-[#C9A227]" data-testid="appointment-response-page">
        <h1 className="font-['Playfair_Display'] text-2xl font-bold text-[#283880] mb-1">{t.pageTitle}</h1>
        {appt && <p className="text-sm text-slate-500 mb-6" data-testid="appointment-pratica">{t.file}: {appt.titolo} ({appt.numero_pratica})</p>}
        {!appt && !failed && <Loader2 className="w-6 h-6 animate-spin text-[#283880]" />}
        {failed && <p className="text-sm text-red-600" data-testid="appointment-invalid">{t.invalid}</p>}
        {appt && <AppointmentCard appt={appt} lang={lang} onRespond={respond} initialAction={params.get('azione')} error={error} />}
      </div>
    </div>
  );
}
